import type React from 'react';
import { useEffect } from 'react';

import { InstitutionFuturesProgressStep, useProgress } from '@/context/progress';
import BaseLayout from '@/layouts/base';

const InstitutionFuturesCompanyInformationLayout = (props: React.ComponentPropsWithoutRef<typeof BaseLayout>) => {
  const { setCurrentStep } = useProgress();

  useEffect(() => {
    return setCurrentStep(InstitutionFuturesProgressStep.INSTITUTION_INFORMATION_FUTURES);
  }, [setCurrentStep]);

  return <BaseLayout {...props} />;
};
InstitutionFuturesCompanyInformationLayout.displayName = 'InstitutionFuturesCompanyInformationLayout';

export default InstitutionFuturesCompanyInformationLayout;
